export default class NetteTools {
	static componentParams(componentName, params) {
		if(componentName){
			for (const name in params) {
				if (params.hasOwnProperty(name)) {
					params[`${componentName}-${name}`] = params[name];
					delete params[name];
				}
			}
		}
		return params;
	}
}
